<template>
  <MainLayoutV2 section="news">
    <div id="news">
      <h1>News and Announcements</h1>

      <PostPreviewExtended
        v-for="post of sorted_visible_posts"
        :key="post.path"
        :_post="post" />

      <div id="load_more">
        <a class="link_button" @click="loadMore">
          Load More
        </a>
      </div>
    </div>
  </MainLayoutV2>
</template>

<script>
import MainLayoutV2 from "@/components/V2/layout/MainLayoutV2"
import PostPreviewExtended from "@/components/V2/PostPreviewExtended"
import HasPosts from "@/mixins/HasPosts"

export default {
  name: "NewsV2",

  mixins: [
    HasPosts
  ],

  components: {
    MainLayoutV2,
    PostPreviewExtended
  }
}
</script>

<style scoped lang="scss">
@import '@/scss/custom.scss';

#news{
  color: $white;
  width: 60%;
  margin: auto;
  padding-top: 125px;
  padding-bottom: 50px;
}

#main_layout_v2.xs #news{
  width: 85%;
}

#news h1{
  font-family: Bricolage Grotesque ExtraBold;
  text-align: center;
}

#main_layout_v2.xs #news h1{
  font-size: 1.5rem;
}

#load_more{
  display: flex;
  justify-content: center;
  cursor: pointer;
}

#load_more .link_button{
  min-width: 200px;
  text-align: center;
  font-family: Bricolage Grotesque ExtraBold;
  font-size: 24px;
  color: $white;
}

#load_more a:hover{
  text-decoration: none;
}
</style>
